import { type ReactNode } from "react";
import { CoBrandHeader } from "./CoBrandHeader.tsx";
import { PoweredByFooter } from "./PoweredByFooter.tsx";

interface Props {
  branding?: { logoUrl: string | null; name: string | null };
  children: ReactNode;
}

/** Consistent layout for every public surface: co-brand header + content + footer. */
export function PageShell({ branding, children }: Props) {
  return (
    <div className="mx-auto flex min-h-full max-w-md flex-col bg-white shadow-sm">
      {branding ? <CoBrandHeader logoUrl={branding.logoUrl} name={branding.name} /> : null}
      <main className="flex flex-1 flex-col px-4 py-6">{children}</main>
      <PoweredByFooter />
    </div>
  );
}
